import React from 'react';
import { useNavigate } from 'react-router-dom';

export const ReferredExtensionDevicesModalContent = ({
	devicesList
}: {
	devicesList: string[];
}) => {
	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                 w-4/6 h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col"
		>
			<section
				className="relative bg-white w-full max-h-screen overflow-y-auto h-screen
                                dark:bg-gray-900 transition-colors duration-300 rounded-t-xl"
			>
				<div className="mx-auto max-w-lg w-10/12 my-10">
					{devicesList.map((item: string) => (
						<UserElement deviceId={item} />
					))}
				</div>
			</section>
		</div>
	);
};

function UserElement({ deviceId }: { deviceId: string }) {
	const navigate = useNavigate();
	return (
		<div className="relative group bg-gray-300 dark:bg-gray-700 mt-2 w-full h-fit flex flex-col items-start rounded-lg overflow-hidden ">
			<div
				className="w-full h-full flex items-start align-middle px-4 py-3 dark:hover:bg-gray-600 hover:bg-gray-400 cursor-pointer"
				onClick={() => {
					navigate(`../deviceid-user-list/${deviceId}`);
				}}
			>
				<div className="font-medium text-sm mt-0.5 text-gray-800 dark:text-white ">
					{deviceId}
				</div>
			</div>
		</div>
	);
}
